var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.7998,
    y: 4.80078,
    width: 23.2,
    height: 22.4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3337 2.66602H4.66699C4.13656 2.66602 3.62785 2.87673 3.25278 3.2518C2.87771 3.62687 2.66699 4.13558 2.66699 4.66602V27.3327C2.66699 27.8631 2.87771 28.3718 3.25278 28.7469C3.62785 29.122 4.13656 29.3327 4.66699 29.3327H27.3337C27.8641 29.3327 28.3728 29.122 28.7479 28.7469C29.1229 28.3718 29.3337 27.8631 29.3337 27.3327V4.66602C29.3337 4.13558 29.1229 3.62687 28.7479 3.2518C28.3728 2.87673 27.8641 2.66602 27.3337 2.66602ZM10.667 25.3327H6.66699V13.3327H10.667V25.3327ZM8.66699 10.9993C8.20857 10.9862 7.76417 10.8383 7.38933 10.5741C7.01448 10.3099 6.72581 9.94106 6.55939 9.51372C6.39296 9.08637 6.35616 8.61945 6.45358 8.17131C6.551 7.72317 6.77832 7.31367 7.10714 6.99398C7.43596 6.67429 7.8517 6.45859 8.30241 6.37383C8.75312 6.28907 9.21881 6.33901 9.64131 6.51741C10.0638 6.6958 10.4243 6.99474 10.6779 7.37688C10.9315 7.75902 11.0668 8.20741 11.067 8.66602C11.0565 9.29315 10.7981 9.89061 10.3484 10.3278C9.89868 10.7651 9.29417 11.0065 8.66699 10.9993ZM25.3337 25.3327H21.3337V19.0127C21.3337 17.1193 20.5337 16.4393 19.4937 16.4393C19.1887 16.4596 18.8908 16.54 18.6171 16.6758C18.3433 16.8115 18.099 17 17.8983 17.2305C17.6976 17.4609 17.5444 17.7288 17.4475 18.0186C17.3506 18.3084 17.3119 18.6145 17.3337 18.9193C17.327 18.9814 17.327 19.044 17.3337 19.106V25.3327H13.3337V13.3327H17.2003V15.066C17.5904 14.4727 18.1262 13.9894 18.7566 13.6626C19.3869 13.3357 20.0906 13.1762 20.8003 13.1993C22.867 13.1993 25.2803 14.346 25.2803 18.0793L25.3337 25.3327Z",
    fill: "#0A66C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinBlue);
export default __webpack_public_path__ + "static/media/linkedin-blue.fd3690828dc3eae4556370047e1a2896.svg";
export { ForwardRef as ReactComponent };